import {useEffect} from 'react'

import {subscribeOnBuildTypeStatus, subscribeOnProjectStatus} from '../actions/statuses'
import {getBuildType, getProject} from '../selectors'
import type {Branch} from '../services/rest'
import type {BuildTypeId, ProjectId} from '../types'

import {useBranch} from './routes'

import {useAppDispatch, useAppSelector} from 'src/hooks/react-redux'

type Props = {
  projectId?: ProjectId | null | undefined
  buildTypeId?: BuildTypeId | null | undefined
  branch?: Branch | null | undefined
  withoutBranch?: boolean
  blockUpdates?: boolean
  updateOverviewParents?: boolean
  timeout?: number | undefined
}

export default ({
  projectId,
  buildTypeId,
  branch,
  withoutBranch,
  blockUpdates,
  updateOverviewParents,
  timeout,
}: Props) => {
  const dispatch = useAppDispatch()

  const branchFromQuery = useBranch()
  const internalBranch = branch == null && withoutBranch !== true ? branchFromQuery : branch

  const projectInternalId = useAppSelector(state => getProject(state, projectId)?.internalId)
  const buildTypeInternalId = useAppSelector(state => getBuildType(state, buildTypeId)?.internalId)

  useEffect(() => {
    if (blockUpdates !== true && projectId && projectInternalId) {
      return dispatch(
        subscribeOnProjectStatus(
          projectId,
          projectInternalId,
          internalBranch,
          timeout,
          updateOverviewParents,
        ),
      )
    }
    return undefined
  }, [
    projectId,
    projectInternalId,
    internalBranch,
    blockUpdates,
    updateOverviewParents,
    timeout,
    dispatch,
  ])

  useEffect(() => {
    if (blockUpdates !== true && buildTypeId && buildTypeInternalId) {
      return dispatch(
        subscribeOnBuildTypeStatus(buildTypeId, buildTypeInternalId, internalBranch, timeout),
      )
    }
    return undefined
  }, [buildTypeId, buildTypeInternalId, internalBranch, blockUpdates, timeout, dispatch])
}
